import { Component, inject, signal } from '@angular/core';
import { Router } from '@angular/router';
import { FormsModule } from '@angular/forms';

import { UI } from '../../components/ui';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-verify-email',
  standalone: true,
  imports: [FormsModule, ...UI],
  templateUrl: './verify-email.component.html',
})
export class VerifyEmailComponent {
  private readonly auth = inject(AuthService);
  private readonly router = inject(Router);

  readonly loading = signal(false);
  readonly resending = signal(false);
  readonly message = signal<string | null>(null);
  readonly error = signal<string | null>(null);
  readonly otpId = signal<string | null>(null);
  readonly maskedDestination = signal<string | null>(null);
  code = '';

  resend(): void {
    this.error.set(null);
    this.message.set(null);
    this.resending.set(true);
    this.auth.resendEmailVerification().subscribe((res) => {
      this.resending.set(false);
      if (!res) {
        this.error.set('Could not send verification email. Please try again.');
        return;
      }
      this.otpId.set(res.otp_id);
      this.maskedDestination.set(res.masked_destination);
      this.message.set('Verification email sent.');
    });
  }

  verify(): void {
    this.error.set(null);
    this.message.set(null);
    const otpId = this.otpId();
    if (this.loading()) {
      return;
    }
    if (!otpId || !this.code.trim()) {
      this.error.set('Resend first and enter the verification code.');
      return;
    }
    this.loading.set(true);
    this.auth.verifyEmail(otpId, this.code.trim()).subscribe((ok) => {
      this.loading.set(false);
      if (!ok) {
        this.error.set('Invalid or expired code.');
        return;
      }
      this.router.navigate(['/app']);
    });
  }
}
